export default function formatMoney(number?: number) {
	if (number == null) return number;

	const userLocale = navigator.language;
	const formattedNumber = new Intl.NumberFormat(userLocale, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(number);

	return formattedNumber;
}
